import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';

@Component({
  selector: 'app-city-combo-select-dialog',
  templateUrl: './city-combo-select-dialog.component.html',
  styleUrls: ['./city-combo-select-dialog.component.scss']
})
export class CityComboSelectDialogComponent extends DialogContentBase implements OnInit {

  constructor( public dialog: DialogRef,
    private fb:UntypedFormBuilder) {   super(dialog);  }

  @Input() caption:string;
  @Input() selectedCity:string;
  form: UntypedFormGroup;

  ngOnInit(): void {
    if(!this.selectedCity){
      this.selectedCity = '';
    }
    this.form = this.getForm();
  }

  confirm(){
    const result = this.form.controls['selectedCity'].value;
        this.dialog.close({ text: 'OK' , selectedCity: result});
  }

  cancel() {
    this.dialog.close({ text: 'Cancel' });
  }

  getForm( ) {
    return this.fb.group({
      selectedCity: [this.selectedCity, Validators.required],
    });
  }
}

